export interface ProductStatus {
  isPurchased: boolean;
  isEnabled: boolean;
  isUpdateAvailable: boolean;
  isExipred?: boolean;
  paidDetails?: any; // Replace 'any' with proper type if available
}

export interface ProductConfig {
  id: string;
  name: string;
  appCode: string;
  baseUrl: string;
  icon: React.ComponentType<{ className?: string }>;
  iconColor: string;
  description: string;
  features: string[];
}

export interface ProductCardProps {
  config: ProductConfig;
  status: ProductStatus;
  onAction: () => void;
  variants?: any; // Replace with proper framer-motion variant type if needed
  isUpdatePlan?: boolean;
  planUpdateAction?: () => void;
}

export interface ProductStatusProps {
  status: ProductStatus;
}
export const BASIC_TIER = "Basic";
export const PRO_TIER = "Pro";
export const ENTERPRISE_TIER = "Enterprise";

export type ProductTier =
  | typeof BASIC_TIER
  | typeof PRO_TIER
  | typeof ENTERPRISE_TIER;

export type AllowedProductNames = "Nexbot" | "Nexcode";
